import { Directive, ElementRef, HostListener } from "@angular/core";

@Directive({ selector: "[OnlyNumbers]" })
export class OnlyNumbersDirective {
  constructor(private hostElement: ElementRef) {}

  //accept only inputs number(replace non num with empty)
  @HostListener("input") onInput() {
    const value = this.hostElement.nativeElement.value;
    const numericValue = value.replace(/\D/g, "");

    if (value !== numericValue) {
      this.hostElement.nativeElement.value = numericValue;
    }
  }
}
